// src/config/version.js
export const APP_VERSION = '2.1.1';
export const APP_NAME = 'Amlo';

// Version information object
export const versionInfo = {
  version: APP_VERSION,
  name: APP_NAME,
  buildDate: new Date().toISOString(),
  features: [
    'Fixed mobile gallery image visibility issues',
    'Removed navigation animations for snappier performance',
    'Enhanced mobile responsiveness',
    'Improved image loading and caching',
    'Better offline functionality',
    'Production-ready stability improvements'
  ],
  production: true,
  releaseNotes: {
    '2.1.1': [
      'Fixed mobile gallery not showing all images',
      'Removed navigation animations for faster performance',
      'Enhanced mobile user experience',
      'Improved app stability and reliability'
    ]
  }
};

// Function to get formatted version string
export const getVersionString = () => {
  return `v${APP_VERSION}`;
};

// Function to get full version info
export const getVersionInfo = () => {
  return {
    ...versionInfo,
    formattedVersion: getVersionString()
  };
}; 